import { Box, Link } from '@mui/material';
import { HomeScreen, Loader } from 'src/components';
import { useGetHomePageSetings } from 'src/hooks/fetch/use-get-home-page-settings.hook';

export default function WelcomePage() {
  const { data, isLoading } = useGetHomePageSetings();

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      {data?.show_journey_home_page && <HomeScreen />}
      {!data?.show_journey_home_page &&
      <Box id="index__pages-welcome__box__l16"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}
      px={3}>
        
          <Link id="index__pages-welcome__link__l25"
        href="https://www.trackgood.io/"
        target="_self"
        rel="noopener"
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          '& img': {
            width: '100%',
            height: 'auto',
            maxWidth: '600px',
            borderRadius: 1,
            boxShadow: 3,
            transition: 'transform 0.3s, box-shadow 0.3s',
            '&:hover': {
              transform: 'scale(1.02)',
              boxShadow: 6
            }
          }
        }}>
          
            <img id="index__pages-welcome__img__l47"
          src="https://cdn.prod.website-files.com/660f1e6a199b25443c7ab8e8/6639d0a96ef41440f2471f84_trackgood-hero-final-p-800.png"
          alt="Welcome to Trackgood" />
          
          </Link>
        </Box>
      }
    </>);

}